export default {
  highlight: {
    GREEN: "#46b630",
    RED: "#d5473f",
    YELLOW: "#fcd800",
    LIGHT_BLUE: "#2077a8"
  },
  text: {
    DARK_BLUE: "#081422",
    GRAY: "#8b8b8b",
    YELLOW: "#dbb800",
    LIGHT_GRAY: "#bac5cb",
    HIT_GRAY: "#acb5be"
  },
  background: {
    DARK_RED: "#8b181b",
    DARK_BLUE: "#273042",
    GRAY_BLUE: "#354251",
    LIGHT_GRAY: "#f2f2f2",
    GRAY: "#e0e0e0"
  },
  bannerText: "#384655",
  bannerLinkText: "white",
  authInfoText: "#384655",
  tableHeadingBackground: "#384655",
  tableHeadingText: "#f2f2f2",
  formHeadingColor: "#969696",
  bgColorDarkStripes: i => (i % 2 === 0 ? "#313d4b" : "#394553"),
  editLadsLabelText: "#aaa",
  linkText: "#337ab7",
  buttonBarBorder: "#aaa",
  geofence: {
    fillColor: "rgba(252, 216, 0, 0.2)",
    strokeColor: "rgba(252, 216, 0, 1.0)"
  },
  locationsHeaderBackground: "#2a363d"
};

export const shadeColor = (color, percent) => {
  var f = parseInt(color.slice(1), 16),
    t = percent < 0 ? 0 : 255,
    p = percent < 0 ? percent * -1 : percent,
    R = f >> 16,
    G = (f >> 8) & 0x00ff,
    B = f & 0x0000ff;
  return (
    "#" +
    (
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)
  );
};



// WEBPACK FOOTER //
// ./src/styles/colors.js